import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { getCategoryBySlugWithBlogPagePosts } from '../../../api/services/blogPostCategoriesApi';

import BlogLayout from '../../../components/main/blog/BlogLayout/BlogLayout';
import BlogPostExcerptsList from '../../../components/main/blog/BlogPostExcerptsList/BlogPostExcerptsList';
import BlogSideBar from '../../../components/main/blog/BlogSideBar/BlogSideBar';
import LinkifiedText from '../../../components/shared/LinkifiedText/LinkifiedText';

import './BlogCategory.css';

const BlogCategory = () => {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoadingCategory, setIsLoadingCategory] = useState(true);

  const getCategoryWithBlogPosts = useCallback(async () => {
    setIsLoadingCategory(true);
    try {
      const categoryWithBlogPosts =
        await getCategoryBySlugWithBlogPagePosts(slug);
      setCategory(categoryWithBlogPosts.category);
      setBlogPosts(categoryWithBlogPosts.posts);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadingCategory(false);
    }
  }, [slug]);

  useEffect(() => {
    getCategoryWithBlogPosts();
  }, [getCategoryWithBlogPosts]);

  if (isLoadingCategory) return <p>Loading...</p>;

  return (
    <div className='blog-category-page-container'>
      <div className='blog-category-title-container'>
        <h1 className='blog-category-title'>BLOG</h1>
      </div>
      <BlogLayout sidebar={<BlogSideBar />}>
        <h2>Category: {category.name}</h2>
        <div className='blog-category-description-container'>
          <LinkifiedText>{category.description}</LinkifiedText>
        </div>
        <hr />
        <BlogPostExcerptsList
          blogPosts={blogPosts}
          isLoading={isLoadingCategory}
        />
      </BlogLayout>
    </div>
  );
};

export default BlogCategory;
